export const MALE = "m";

export const FEMALE = "f";
